module.exports = __webpack_public_path__ + "img/product_70.218744e.svg";